import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-berechtigung-entfernen-multi';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentBerechtigungEntfernenMultiEffects {

    DokumentBerechtigungEntfernenMulti$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_BERECHTIGUNG_ENTFERNEN_MULTI),
        mergeMap((x: ac.PostDokumentBerechtigungEntfernenMultiAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentBerechtigungEntfernenMulti(x.dokumentBerechtigungRolleMultiRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentBerechtigungEntfernenMultiErfolgreichAction(result, x.dokumentBerechtigungRolleMultiRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentBerechtigungEntfernenMultiFehlerAction(error, x.dokumentBerechtigungRolleMultiRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
